import React, { useEffect, useState } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactHtmlParser from 'react-html-parser';
import * as routes from '../../../../constants/routes';
import { getLegalAdviceQuestion, resetLegalAdviceQuestion } from '../../../../redux/actions';
import { convertDateToReadableFormat } from '../../../../app/functions';
import questionIcon from '../../../../assets/icons/question-icon.svg';
import answerIcon from '../../../../assets/icons/answer-icon.svg';
import TopBanner from '../../sections/top_banner';
import Tag from '../../../../components/common/shared/tag';
import { useGetLegalAdviceQuestionQuery, useGetLegalAdvicePageQuery } from '../../../../redux/api/relations.api';
import './index.scss';

const QuestionRoute = ({legalAdvicePage}) => {
    const { id, token } = useParams();

    const dispatch = useDispatch();

    
    const translations = useSelector((store) => store.config.Translations);
    const { data: legalAdviceQuestionData, error, isLoading } = useGetLegalAdviceQuestionQuery({question_id: id});
    const [legalAdviceQuestion, setLegalAdviceQuestion] = useState(null);
    const category = legalAdvicePage.categories[legalAdviceQuestion?.question?.category_id];

    useEffect(() => {
        if (legalAdviceQuestionData) {
            setLegalAdviceQuestion(legalAdviceQuestionData);
        }
    }, [legalAdviceQuestionData]);
    useEffect(() => {
        const requestPayload = { question_id: id };

        if (token) {
            requestPayload['preview_token'] = token;
        }

        return () => dispatch(resetLegalAdviceQuestion());
    }, [id, legalAdviceQuestionData]);

    return legalAdviceQuestion && (
        <>
            <TopBanner
                legalAdvicePage={legalAdvicePage}
                additionalBreadcrumb={{
                    text: 'שאלה',
                    route: routes.legal_advice_routes.view_question,
                }}
            >
                <h3 className="banner-title banner-title_route_question">
                    {translations['legal_advice_view_question_title'] + ' '}
                    {category?.title}
                </h3>
            </TopBanner>

            <div className="legal-advice-question-route content-container">
                <article className="question-container">
                    <div className="question-title-container">
                        <img
                            src={questionIcon}
                            alt="Question Icon"
                            className="question-title-icon"
                        />

                        <h4 className="question-title">
                            {translations['legal_advice_view_question_question_subtitle']}
                        </h4>

                        <div className="question-tags-container">
                            {legalAdviceQuestion.question.linked_tags.map((tagId) => {
                                const tagData = legalAdvicePage.tags.find((tag) => tag.id === tagId);

                                return tagData && (
                                    <NavLink key={tagData.id} to={routes.legal_advice + '/' + tagData.id} >
                                        <Tag data={tagData} />
                                    </NavLink>
                                );
                            })}
                        </div>
                    </div>

                    <p className="question-date">
                        {convertDateToReadableFormat(legalAdviceQuestion.question.created_at * 1000)}
                    </p>

                    <div className="question-textual-content question-textual-content_spaced">
                        {ReactHtmlParser(legalAdviceQuestion.question.question_content)}
                    </div>

                    <div className="question-title-container">
                        <img
                            src={answerIcon}
                            alt="Answer Icon"
                            className="question-title-icon"
                        />

                        <h4 className="question-title">
                            {translations['legal_advice_view_question_answer_subtitle']}
                        </h4>
                    </div>

                    <div className="question-textual-content">
                        {ReactHtmlParser(legalAdviceQuestion.question.answer_content)}

                        <p className="disclaimer">
                            {translations['legal_advice_view_question_legal_message']}
                        </p>
                    </div>
                </article>

                {/*{legalAdviceQuestion.benefits?.length > 0 && (*/}
                {/*    <aside className="benefits-container">*/}
                {/*        <h4 className="benefits-title">*/}
                {/*            {translations['legal_advice_view_question_benefits_subtitle']}*/}
                {/*        </h4>*/}
                {/*        <div className="benefits-grid">*/}
                {/*            {legalAdviceQuestion.benefits.map((benefitData) => (*/}
                {/*                <Benefit key={benefitData.id} data={benefitData} />*/}
                {/*            ))}*/}
                {/*        </div>*/}
                {/*    </aside>*/}
                {/*)}*/}
            </div>
        </>
    );
};

export default QuestionRoute;
